import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

interface IAgreementPassportTypeCell {
  passportType: string;
}

export function AgreementPassportTypeCell<T extends IAgreementPassportTypeCell>({
  row,
}: Readonly<ITableRenderCell<T>>) {
  if (row.passportType === 'PM') {
    return <div>ПМ</div>;
  }

  if (row.passportType === 'KNM') {
    return <div>КНМ</div>;
  }

  return <div>Иные решения</div>;
}
